import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import {useEffect} from 'react';
import {encryptResponse,decryptRequest} from './Service';
// import errorimg from '';
function Alert({closedialog,status,dataPass}) { 
  useEffect(()=>{  
  },[])
  return (
    <div className='contailer_main'>
      {
        status== 0?(
          <div className="container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="icon"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
      />
    </svg>
    <span className="title">Congratulations</span>
    <span className="subtitle">Lead created successfully.</span>
    <span className="subtitle">Lead ID: {dataPass?.Prospect_Number__c}</span>
    <button className="btn" onClick={()=>closedialog()}>
      Dashboard
    </button>
    </div>
        ):(
          <div className='dialogcls'> 
     
        <img src="/error.png" /> 
    <span style={{fontWeight:'800',fontSize:'xx-large'}}>Sorry</span>  
    <div style={{display:'flex',gap:'5px',width:'100%',margin:'10px',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
      <span>Error message:</span>
      <span style={{fontWeight:'700'}}>{dataPass.errorMessage ?? 'N/A'}</span>
    </div>
  

    <button style={{width:'90%',backgroundColor:'#003366',padding:'10px',color:'white'}} onClick={()=>closedialog()}>Home</button>
    </div>
        )
      }
    


    
</div>
  );
}

export default Alert;
